/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { yellow } from "@mui/material/colors";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useMediaQuery } from "@mui/material";
import { MOBLIE_VIEW_WIDTH } from "../../constants/constants";
import { useEffect, useState } from "react";

const quickLinkBox = (matchesMob) => css`
  &:hover {
    transform: scale(1.05);
    transition: 0.7s ease;
  }
  width: ${matchesMob ? "230px" : "75px"};
  height: ${matchesMob ? "190px" : "60px"};
  ${matchesMob ? "margin: 15px;" : "margin: 5px;"}
  background-color: #424040;
  position: relative;
`;

const quickDiv = (matchesMob) => css`
  display: flex;
  position: absolute;
  top: ${matchesMob ? "85%" : "105%"};
  right: ${matchesMob ? "5%" : "0"};
  align-items: center;
`;

const quickLinkText = (matchesMob) => css`
  font-size: ${matchesMob ? "14px" : "13px"};
  color: #ffffff;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

const LinkComp = styled(Link)(() => ({}));
const handleLinkClick = (url) => {
  if (url?.slice(0, 1) !== "/") window.open(url, "_blank");
};
export default function QuickLinksComp({ quickLinksData }) {
  const [tcoBg, setTcoBg] = useState([]);
  const [flag, setFlag] = useState(false);
  const [value, setValue] = useState(-1);
  const matches = useMediaQuery(MOBLIE_VIEW_WIDTH);

  useEffect(() => {
    const arr = [];
    quickLinksData?.map((item) => {
      if (item?.QRCode?.data) {
        arr.push({
          bg:
            process.env.REACT_APP_BASEURL + item?.image?.data?.attributes?.url,
          qr:
            process.env.REACT_APP_BASEURL + item?.QRCode?.data?.attributes?.url,
        });
      } else {
        arr.push({
          bg:
            process.env.REACT_APP_BASEURL + item?.image?.data?.attributes?.url,
        });
      }
    });
    setTcoBg([...arr]);
  }, [quickLinksData]);

  const handleQuickLinkHover = (val, index) => {
    setFlag(val);
    setValue(index);
  };
  return (
    <>
      {quickLinksData.map((item, index) => (
        <LinkComp
          to={item?.ctaLink?.slice(0, 1) === "/" ? item?.ctaLink : "#"}
          onClick={() => handleLinkClick(item.ctaLink)}
          id="quickLinksBox"
          key={item?.Title}
          css={() => quickLinkBox(matches)}
          style={{
            backgroundImage:
              flag && value === index && tcoBg[index]?.qr
                ? `url(${tcoBg[index]?.qr})`
                : `url(${tcoBg[index]?.bg})`,
            backgroundSize:
              flag && value === index && tcoBg[index]?.qr ? "50%" : "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
          href={item?.ctaLink}
          onMouseEnter={() => matches && handleQuickLinkHover(true, index)}
          onMouseLeave={() => matches && handleQuickLinkHover(false, -1)}
        >
          <div css={() => quickDiv(matches)}>
            <span css={() => quickLinkText(matches)}>{item.Title}</span>
            {item.Title && matches && (
              <ArrowRightAltIcon sx={{ color: yellow[50] }}></ArrowRightAltIcon>
            )}
          </div>
        </LinkComp>
      ))}
    </>
  );
}
